module.exports = __webpack_public_path__ + "img/c-4.62013d63.png";